import { ProductSlug } from "@/api/product-api";
import { useProducts } from "@/services/product/useProductService";
import { create } from "zustand";

type BundledState = {
  bundle: ProductSlug | null;
  isOpen: boolean;
};

type BundledAction = {
  setBundle: (data: { bundle: ProductSlug | null; isOpen?: boolean }) => void;
  close: () => void;
};

type BundledStore = BundledState & BundledAction;

export const bundledStore = create<BundledStore>()((set) => ({
  bundle: null,
  isOpen: false,
  setBundle: ({ bundle, isOpen }) =>
    set({
      bundle,
      isOpen: isOpen ?? false,
    }),
  close: () => set({ isOpen: false }),
}));

export const useBundledStore = <T>(selector: (state: BundledStore) => T): T =>
  bundledStore(selector);

export const getBundledState = () => bundledStore.getState();

export const useBundledProductName = (): string | null => {
  const bundle = useBundledStore((s) => s.bundle);
  const products = useProducts();
  const product = products.data?.find((product) => product.slug === bundle);
  return product?.name ?? bundle;
};
